import { Component, computed, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent
} from '../sections/location-of-devices-unrelated-to-road-occupation-section/components/location-of-devices-unrelated-to-road-occupation-preview/location-of-devices-unrelated-to-road-occupation-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormValue,
  occupationsToFormValue
} from '../sections/location-of-devices-unrelated-to-road-occupation-section/forms/location-of-devices-unrelated-to-road-occupation.form';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    DecisionDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    ContractorDataPreviewComponent,
    LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-preview.component.html'
})
export class LocationOfDevicesUnrelatedToRoadPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupations: Signal<LocationOfDevicesUnrelatedToRoadOccupationFormValue[]> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []));

}
